import { ClientInput } from 'admin/inputs/ClientInput';
import { DateInput } from 'admin/inputs/DateInput';
import { Create, SimpleForm, TextInput } from 'react-admin';

export const FinancialAdvisorTaskCreate: React.FC = () => (
  <Create>
    <SimpleForm>
      <ClientInput label="Klient" source="clientId" />
      <TextInput label="Typ" required source="title" sx={{ maxWidth: '40em', width: '100%' }} />
      <TextInput label="Podtyp" required source="subtitle" sx={{ maxWidth: '40em', width: '100%' }} />
      <TextInput label="Úloha" required source="text" sx={{ maxWidth: '40em', width: '100%' }} />
      <DateInput label="Dátum úlohy" required source="dueDate" />
    </SimpleForm>
  </Create>
);
